module.exports = __webpack_public_path__ + "static/img/blo8.1e4931ca.jpg";